import { NextSeo } from 'next-seo'

// import { GetServerSideProps } from 'next'
// import { QueryClient } from 'react-query'
import { loadStripe } from '@stripe/stripe-js'
// import { dehydrate } from 'react-query/hydration'
import { Elements } from '@stripe/react-stripe-js'

// import { fetchCart } from '@hooks/price/fetchers'
import { SlimHeader } from '@components/SlimHeader'
// import { fetchAffiliateInfo } from '@hooks/affiliate-info'
import { CheckoutForm } from '@components/checkout/CheckoutForm'
import { Header } from '@components/Header'

const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_API_KEY ?? '')

export default function Checkout() {
  return (
    <main className="bg-gray-100">
      <Elements stripe={stripePromise}>
        <NextSeo
          title="Checkout"
          description="Purchase a Home Repair Estimate to decipher your home inspection and uncover actionable, cost-estimated repair insights."
        />
        {/* <SlimHeader title="Order a Home Repair Estimate" /> */}

        <Header />
        <CheckoutForm />
      </Elements>
    </main>
  )
}

// export const getServerSideProps: GetServerSideProps = async ({
//   query,
//   req
// }) => {
//   // If we are currently in a Netlify function (deployed on netlify.app or
//   // locally with netlify dev), do not wait for empty event loop.
//   // See: https://stackoverflow.com/a/39215697/6451879
//   const { context } = (req as any).netlifyFunctionParams || {}
//   // Skip during next dev.
//   if (context) {
//     context.callbackWaitsForEmptyEventLoop = false
//   }

//   const queryClient = new QueryClient()
//   await queryClient.prefetchQuery(
//     [
//       'cart',
//       {
//         promoCode: '',
//         partner: query.ref ?? '',
//         affiliate: query.affiliate ?? ''
//       }
//     ],
//     fetchCart(req)
//   )

//   if (query.ref) {
//     await queryClient.prefetchQuery(
//       ['partner', query.ref],
//       fetchAffiliateInfo(req)
//     )
//   }

//   return {
//     props: {
//       dehydratedState: dehydrate(queryClient)
//     }
//   }
// }
